import React from 'react';
import PropTypes from 'prop-types';
import RedirectChoice from './RedirectChoice';
import useRouter from '../../../hooks/useRouter';
import { NewspaperIcon } from '@heroicons/react/24/outline';

export default function OfferResourceChoice(props) {
  const { history } = useRouter();

  return (
    <RedirectChoice
      icon={NewspaperIcon}
      title="Offer a resource or opportunity to support educators and learners."
      onClick={() => history.push({
        pathname: '/my-leading',
      })}
    />
  );
};
